import { ComponentMeta, Story as GenericStory } from "@storybook/react";
import React from "react";
import { VerticalNavigationMenu } from ".";
import Flex from "../Flex/Flex";
import Typography from "../Typography/Typography";

type Props = React.ComponentProps<typeof VerticalNavigationMenu>;
type Story = GenericStory<Props>;

export default {
    title: "common/VerticalNavigationMenu",
    component: VerticalNavigationMenu
} as ComponentMeta<typeof VerticalNavigationMenu>;

const Box = ({ elementId, hasIssues, title }: Props["menuItems"][number]) => {
    return (
        <Flex
            alignItems="center"
            backgroundColor={hasIssues ? "error-100" : "surface-100"}
            borderColor={hasIssues ? "error-600" : "surface-100"}
            borderRadius={8}
            borderStyle="solid"
            borderWidth={1}
            justifyContent="center"
            column
            id={elementId}
            height={800}
            style={{ scrollMarginTop: 16 }}
        >
            <Typography color="surface-1200" variant="label-medium-semibold">
                {title}
            </Typography>
        </Flex>
    );
};

const Template: Story = args => (
    <Flex alignItems="flex-start" gap={16}>
        <VerticalNavigationMenu {...args} />

        <Flex column grow={1}>
            {args.menuItems.map(item => (
                <Flex key={item.elementId} column py={16}>
                    <Box {...item} />
                </Flex>
            ))}
        </Flex>
    </Flex>
);

export const Default = Template.bind({});
Default.args = {
    menuItems: [
        { elementId: "first", title: "First section" },
        { elementId: "second", title: "Second section" },
        { elementId: "third", hasIssues: true, title: "Third section" },
        { elementId: "fourth", title: "Fourth section" }
    ]
} satisfies Props;
